import App from "./App";
//import Completed from "./components/FirstSetup/Completed";
import PageError from "./components/PageError";
import { createBrowserRouter, Navigate } from "react-router-dom";
import { ANALYTICS_ENABLED } from "./constants/features";
//import Save from "./components/FirstSetup/Save";
import BrandCreation from "./components/Dashboard/MenuTabs/BrandCreation";
import ServicesList from "./components/Dashboard/MenuTabs/ServicesList";
import ServiceEdit, {
    loader as serviceEditLoader,
} from "./components/Dashboard/MenuTabs/ServiceEdit";
//import LocationsEdit from "./components/Dashboard/MenuTabs/LocationsEdit";
import ProfileEdit from "./components/Dashboard/MenuTabs/ProfileEdit";
import Subscriptions from "./components/Dashboard/MenuTabs/Subscriptions";
import Calendar from "./components/Dashboard/Calendar/Calendar";
import UsersList from "./components/Dashboard/Users/UsersList";
import UserInfo, {
    loader as userInfoLoader,
} from "./components/Dashboard/Users/UserInfo";
import UserLink, {
    loader as userLinkLoader,
} from "./components/Dashboard/Users/UserLink";
import Share from "./components/Dashboard/MenuTabs/Share";
import ChatsList from "./components/Dashboard/Chat/ChatsList";
import ClientChat, {
    loader as clientChatLoader,
} from "./components/Dashboard/Chat/ClientChat";
import UserRegistration from "./components/Dashboard/Users/UserRegistration";
import BookingInfo, {
    loader as serviceInfoLoader,
} from "./components/Dashboard/Calendar/BookingInfo";
import NotificationsList from "./components/Dashboard/NotificationsList";
import AutomationEdit from "./components/Dashboard/MenuTabs/AutomationEdit";
import Redirect, { loader as redirectLoader } from "./components/Redirect";
import UserSelect from "./components/Dashboard/Calendar/Add/UserSelect";
import ServiceSelect from "./components/Dashboard/Calendar/Add/ServiceSelect";
import Confirmation from "./components/Dashboard/Calendar/Add/Confirmation";
import ChangeCredential from "./components/Dashboard/MenuTabs/ChangeCredential";
import HealthCheckPage from "./components/HealthCheckPage";
import CheckoutSuccess from "./components/CheckoutSuccess";
import CheckoutFailed from "./components/CheckoutFailed";
import DefaultServiceAdmin from "./components/DefaultServiceAdmin";
import NotificationDetails from "./components/Dashboard/NotificationDetails";
import ExpiredSubscription from "./components/ExpiredSubscription";
import { Login } from "./components/Login";
import Landing from "./components/Landing";
import NotFound from "./components/NotFound";
import ClientsReview from "./components/AIAdmin/ClientsReview";
import Reason from "./components/AIAdmin/CancellationReason";
import FillPromoConfig from "./components/AIAdmin/FillPromoConfig";
import ForgotPassword from "./components/ForgotPassword";
import PartnerDashboard from "./components/Dashboard/MenuTabs/PartnerDashboard";
import WallpaperEdit from "./components/Dashboard/MenuTabs/WallpaperEdit";
import LoyaltyConfig from "./components/Dashboard/MenuTabs/LoyaltyConfig";
import WorkspaceEdit from "./components/Dashboard/MenuTabs/WorkplaceEdit";
import IOSInstallGuide from "./components/iOSInstallGuide";
import Analytics from "./components/Dashboard/Analytics/Analytics";

const router = createBrowserRouter([
    {
        path: "/",
        //loader: subscriptionValidationLoader,
        element: <App />,
        errorElement: <PageError />,
    },
    {
        path: "/login",
        element: <Login />,
    },
    {
        path: "/forgot-password",
        children: [
            { index: true, element: <ForgotPassword /> },
            { path: ":token", element: <ForgotPassword /> },
        ],
    },
    {
        path: "/health/check",
        element: <HealthCheckPage />,
    },
    {
        path: "/redirect/:uuid",
        loader: redirectLoader,
        element: <Redirect />,
    },

    {
        //path: "/setup/services",
        //element: <ServicesList isFirstSetup={true} />,
    },
    {
        //path: "/setup/services/:category_id/:service_id",
        //loader: serviceEditLoader,
        //element: <ServiceEdit isFirstSetup={true} />,
    },

    {
        //path: "/setup/locations",
        //element: <LocationsEdit isFirstSetup={true} />,
        //element: <WorkspaceEdit />,
    },
    {
        //path: "/setup/locations/:location_id",
        //element: <WorkspaceEdit />,
    },

    {
        //path: "/setup/automations",
        //element: <AutomationEdit isFirstSetup={true} />,
    },
    {
        //path: "/setup/profile",
        //element: <ProfileEdit isFirstSetup={true} />,
    },
    {
        //path: "/setup/completed",
        //element: <Completed />,
    },
    {
        //path: "/setup/subscriptions",
        //element: <Subscriptions isFirstSetup={true} />,
    },
    {
        //path: "/setup/save",
        //element: <Save />,
    },

    {
        path: "/menu/brand",
        //loader: subscriptionValidationLoader,
        element: <BrandCreation />,
    },
    {
        path: "/menu/wallpaper",
        //loader: subscriptionValidationLoader,
        element: <WallpaperEdit />,
    },
    {
        path: "/menu/services",
        //loader: subscriptionValidationLoader,
        element: <ServicesList />,
    },
    {
        path: "/menu/services/:category_id/:service_id",
        //loader: withSubscriptionValidation(serviceEditLoader), // To add subscription validation
        loader: serviceEditLoader,
        element: <ServiceEdit />,
    },

    {
        path: "/menu/locations",
        //loader: subscriptionValidationLoader,
        //element: <LocationsEdit />,
        element: <WorkspaceEdit />,
    },
    {
        //path: "/menu/locations/:location_id",
        //element: <WorkspaceEdit />,
    },

    {
        path: "/menu/automations",
        //loader: subscriptionValidationLoader,
        element: <AutomationEdit />,
    },
    {
        path: "/menu/profile",
        //loader: subscriptionValidationLoader,
        element: <ProfileEdit />,
    },
    {
        path: "/menu/subscriptions",
        element: <Subscriptions />,
    },
    {
        path: "/menu/loyalty",
        element: <LoyaltyConfig />,
    },
    {
        path: "/menu/share",
        //loader: subscriptionValidationLoader,
        element: <Share />,
    },
    {
        path: "/menu/password",
        //loader: subscriptionValidationLoader,
        element: <ChangeCredential type="password" />,
    },
    {
        path: "/menu/email",
        //loader: subscriptionValidationLoader,
        element: <ChangeCredential type="email" />,
    },
    {
        path: "/partner",
        element: <PartnerDashboard />,
    },
    {
        path: "/analytics",
        element: ANALYTICS_ENABLED ? <Analytics /> : <Navigate to="/" replace />,
    },
    {
        path: "/calendar",
        //loader: subscriptionValidationLoader,
        element: <Calendar />,
    },
    {
        path: "/calendar/appointment/:booking_id",
        //loader: withSubscriptionValidation(serviceInfoLoader),
        loader: serviceInfoLoader,
        element: <BookingInfo />,
    },
    {
        path: "/calendar/add/user",
        element: <UserSelect />,
    },
    {
        path: "/calendar/add/service",
        element: <ServiceSelect />,
    },
    {
        path: "/calendar/add/confirmation",
        element: <Confirmation />,
    },
    {
        path: "/aiadmin/free-my-day/clients-review",
        //loader: subscriptionValidationLoader,
        element: <ClientsReview />,
    },
    {
        path: "/aiadmin/free-my-day/reason",
        //loader: subscriptionValidationLoader,
        element: <Reason />,
    },
    {
        path: "/aiadmin/fill-my-day/config",
        //loader: subscriptionValidationLoader,
        element: <FillPromoConfig />,
    },
    {
        path: "/users",
        //loader: subscriptionValidationLoader,
        element: <UsersList />,
    },
    {
        path: "/users/info/:client_id",
        //loader: withSubscriptionValidation(userInfoLoader),
        loader: userInfoLoader,
        element: <UserInfo />,
    },
    {
        path: "/users/link/:client_id",
        //loader: withSubscriptionValidation(userLinkLoader),
        loader: userLinkLoader,
        element: <UserLink />,
    },
    {
        path: "/users/registration",
        //loader: subscriptionValidationLoader,
        element: <UserRegistration />,
    },
    {
        path: "/chats",
        //loader: subscriptionValidationLoader,
        element: <ChatsList />,
    },
    {
        path: "/chats/:client_id",
        //loader: withSubscriptionValidation(clientChatLoader),
        loader: clientChatLoader,
        element: <ClientChat />,
    },
    {
        path: "/notifications",
        //loader: subscriptionValidationLoader,
        element: <NotificationsList />,
    },
    {
        path: "/notifications/:notificationKey",
        //loader: subscriptionValidationLoader,
        element: <NotificationDetails />,
    },
    {
        path: "/success",
        element: <CheckoutSuccess />,
    },
    {
        path: "/cancel",
        element: <CheckoutFailed />,
    },
    {
        path: "/expired",
        element: <ExpiredSubscription />,
    },
    {
        path: "/install-ios",
        element: <IOSInstallGuide />,
    },
    {
        path: "/soon",
        element: <Landing />,
    },
    {
        path: "/v81iN23",
        element: <DefaultServiceAdmin />,
    },
    {
        path: "*",
        element: <NotFound />,
    },
]);

export default router;
